import type { Customer } from "src/common/service/nexus/endpoints/customer/types.js";
import type { Builder, PaginatedResponse } from "../../types.js";
import { buildHierarchyEndpoints } from "./hierarchyEndpoints.js";

export const buildCustomerEndpoints = (builder: Builder) => ({
	...buildHierarchyEndpoints(builder),
	getCustomers: builder.query<
		PaginatedResponse<Customer>,
		{ companyDomainId: string; legalEntityId: string; take: number }
	>({
		query: ({ companyDomainId, legalEntityId, take }) => {
			return {
				url: `/v1/company-domain/${companyDomainId}/legal-entity/${legalEntityId}/customer`,
				params: {
					take,
				},
			};
		},
		providesTags: (result) => {
			if (!result) {
				return ["Customer"];
			}
			return [
				"Customer",
				...result.items.map((invoice) => {
					return {
						type: "Customer" as const,
						id: invoice.id,
					};
				}),
			];
		},
	}),
});
